import React, {Component} from 'react'
import {Button, Col, Form, message, Radio, Row, Select, Table} from "antd";
import ajax from "../../../src/api/ajax";
import {baseUrl, reqArea} from "../../../src/api";

const PAGE_SIZE = 10;
class RouteTable  extends Component {
    routeTypes={
        "I":"进口",
        "O":"出口",
    }
    constructor(props, context) {
        super(props, context);
        this.state={
            tableDataSource:[],
            params:{sts:"Y"},
            loading:false,
            pageNum:0,
            total:0,
            editingKey:"",
            origin: [],
            destination: [],
            originCity:"",
            destinationCity:"",
            routeType:"O",
        }
    }
    doSearch=(params=null,page)=>{
        console.log(params,'params')
        this.props.form.validateFields((error, value) => {
            if (error) {
                return;
            }
            if(params){
                this.setState({
                    params:params
                })
                if(params.pageNum){
                    this.setState({
                        pageNum:params.pageNum,
                    })
                }
            }else{
                console.log(123)
                params={...this.state.params}
                console.log(params,page,'ppppp')
                params.pageNum=!!page?page:1;
                this.setState({
                    pageNum:!!page?page:1
                })
            }

            let start =""
            let destination = ""
            for(let item of this.state.origin){
                if(value.originCity === (item.cityId)){
                    start = item.countryName+item.cityName
                }
                if(value.destinationCity === (item.cityId)){
                    destination = item.countryName+item.cityName
                }
            }
            for(let item of this.state.destination){
                if(value.originCity === (item.cityId)){
                    start = item.countryName+item.cityName
                }
                if(value.destinationCity === (item.cityId)){
                    destination = item.countryName+item.cityName
                }
            }

            params = Object.assign(params,value,{start:start,destination:destination})
            console.log(112233,params,value)
            this.getDataSource(params);
        });

    }
    getDataSource=(params=null)=> {
        this.setState({
            loading:true,
        })
        if(!params || !params.pageNum) {
            if(!params){
                params = this.state.params
            }
            params = Object.assign(params,{
                pageNum: this.state.pageNum,
                pageSize: PAGE_SIZE
            })
        }
        let result = ajax(baseUrl+"/api/v1/p/mms/kt/routes",params);
        result.then((resp)=>{
            if(resp.code === 200){
                this.setState({
                    total: resp.data.total,
                    tableDataSource:resp.data.rows
                })
            }else{
                message.error(resp.message)
                this.setState({
                    total: 0,
                    tableDataSource:[]
                })
            }
        }).catch(()=>{
            this.setState({
                total: 0,
                tableDataSource:[]
            })
        }).finally(()=>{
            this.setState({
                loading:false
            })
        })
    }
    init = async () => {
        await this.getCity('', 'F')
        await this.getCity('', 'T')
    }
    getCity = async (cityId, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            if (type === 'F') {
                this.setState({origin: result.data});
            } else if (type === 'T') {
                this.setState({destination: result.data})
            }
        } else {
            message.error(result.message);
        }
    };
    componentDidMount() {
        this.init()
        this.doSearch()
    }
    render() {
        const form = this.props.form
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {span: 8},
            wrapperCol: {span: 15}
        };
        const columns = [
            {
                title: '线路名称',
                dataIndex: 'routeName',
                key: 'routeName',
                render: (text, record, index) => <a onClick={()=>{ this.props.history.push('/route/'+record.id,{readOnly:true})}}>{record.start} - {record.destination}</a>
            },
            {
                title: '线路类型',
                dataIndex: 'type',
                key: 'type',
                render: (text,record) => `${this.routeTypes[text]}`
            },
            {
                title: '操作',
                dataIndex: 'opt',
                key: 'opt',
                fixed: 'right',
                width: 240,
                render: (text, record) => {
                    return(
                        <span>
                            <a onClick={()=>{ this.props.history.push('/route/'+record.id,{readOnly:false})}}>修改</a>
                        </span>
                    )
                }
            }
        ];
        const options1 = this.state.origin.map(d => <Select.Option key={d.cityId}
                                                                   value={d.cityId}>{d.countryName + ' ' + d.cityName}</Select.Option>);
        const options2 = this.state.destination.map(d => <Select.Option
            key={d.cityId} value={d.cityId}>{d.countryName + ' ' + d.cityName}</Select.Option>);
        return (
            <div>
                <div className='box-shadow margin-bootom'>
                    <br/>
                    <Form labelCol={{
                        lg: {span: 7},
                        md: {span: 9},
                    }}
                          wrapperCol={{
                              lg: {span: 14},
                              md: {span: 12},
                          }}
                    >
                        <Row>
                            <Col span={6}>
                                <Form.Item label="起运地">
                                    {getFieldDecorator('originCity', {
                                        initialValue: this.state.originCity,
                                        rules: [{required: false, message: '该项必填'}]
                                    })(<Select style={{ marginRight: '10px'}}
                                               getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Select.Option value=''>全部</Select.Option>
                                        {this.state.routeType==="O"?options1:options2}
                                    </Select>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="目的地">
                                    {getFieldDecorator('destinationCity', {
                                        initialValue: this.state.destinationCity,
                                        rules: [{required: false, message: '该项必填'}]
                                    })(<Select style={{marginRight: '10px'}}
                                               getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Select.Option value=''>全部</Select.Option>
                                        {this.state.routeType==="O"?options2:options1}
                                    </Select>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="线路类型" {...formItemLayout}>
                                    {getFieldDecorator('type', {
                                        rules: [
                                            {
                                                required: false,
                                                message: `请输入!`,
                                            },
                                        ],
                                        initialValue: this.state.routeType,
                                    })(<Radio.Group onChange={(e)=>{
                                        this.setState({routeType:e.target.value},()=>{
                                            let originCity = this.state.originCity
                                            let destinationCity = this.state.destinationCity
                                            this.setState({
                                                originCity:destinationCity,
                                                destinationCity:originCity,
                                            })
                                            this.props.form.setFieldsValue({
                                                originCity:destinationCity,
                                                destinationCity:originCity,
                                            })
                                        })
                                    }}>
                                        <Radio value={'I'}>进口</Radio>
                                        <Radio value={'O'}>出口</Radio>
                                    </Radio.Group>)}
                                </Form.Item>
                            </Col>
                            <Col span={6} style={{float:"right"}}>
                                <Button onClick={()=>{
                                    this.props.history.push('/route/')
                                }} style={{marginRight: 8}} >新增</Button>
                                <Button onClick={()=>{
                                    this.doSearch()
                                }} type="primary">搜索</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow'>
                    <Table
                        bordered
                        size="middle"
                        columns={columns}
                        rowKey={record => record.id}
                        dataSource={this.state.tableDataSource}
                        loading={this.state.loading}
                        pagination={{
                            current: this.state.pageNum,
                            total:this.state.total,
                            pageSize:PAGE_SIZE,
                            showQuickJumper: true,
                            onChange:(page, pageSize)=>{
                                this.setState({
                                    pageNum:page
                                },()=>{
                                    this.doSearch(null,page)
                                })
                            }
                        }}
                    />
                </div>
            </div>
        );
    }
}
const RouteTableForm = Form.create()(RouteTable)
export default RouteTableForm